var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "field1", prop: "field1" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.field1,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "field1", $$v)
                  },
                  expression: "form.field1",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }